module.exports = __webpack_public_path__ + "static/img/big2.c4463a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big2.jpg
// module id = PHTu
// module chunks = 1